import React from 'react';
import { Button, Grid } from 'antd';
import { LuTelescope } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;

const QueryDeepResearchTool = ({ deepResearch, onToggle }) => {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = screens.xs;
  const deepResearchActivateLabel = isMobile ? t('query_new.fields.deep_research_activate_mobile') : t('query_new.fields.deep_research_activate');
  const deepResearchActiveLabel = isMobile ? t('query_new.fields.deep_research_active_mobile') : t('query_new.fields.deep_research_active');

  return (
    <Button
      type={deepResearch ? "primary" : "default"}
      shape="round"
      icon={<LuTelescope size="1.2em" style={{ verticalAlign: 'middle' }} />}
      onClick={onToggle}
      className={`deep-research-pill ${deepResearch ? 'active' : ''}`}
      data-testid="deep-research-toggle"
      style={{
        borderRadius: '20px',
        padding: '4px 16px',
        fontSize: '14px',
        fontWeight: '500',
        border: deepResearch ? 'none' : '1px solid #e8d4ff',
        backgroundColor: deepResearch ? '#722ed1' : '#f9f0ff',
        color: deepResearch ? '#ffffff' : '#722ed1',
        boxShadow: deepResearch ? '0 2px 8px rgba(114, 46, 209, 0.25)' : '0 1px 3px rgba(114, 46, 209, 0.1)',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
      }}
    >
      {deepResearch ? deepResearchActiveLabel : deepResearchActivateLabel}
    </Button>
  );
};

export default QueryDeepResearchTool;